import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { FirmwareServiceProxy, FileInfoDto } from '@/service-proxies/app-v2/console.service-proxies'
import { FirmwareServiceProxy as FirmwareService } from '@/service-proxies/app-v2/iot-console.service-proxies'
import { ServiceProxy as ResourceServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'

const resourceService = new ResourceServiceProxy()
const firmwareService = new FirmwareServiceProxy()
const fsp = new FirmwareService()

@Component
export default class UploadModal extends Vue {
  @Prop(Boolean) readonly visible: false
  @Prop({ default: 'old' }) readonly version: string
  @Prop({ default: () => ([]) }) readonly tenantList: any

  loading = false // 图片上传状态
  file: any = {} // 上传的固件文件
  fileList = []
  tenantIds = [] // 选择的租户

  get dataSource() {
    return this.tenantList.map(item => ({ key: item.tenantId, title: item.tenantCode }))
  }

  @Watch('visible')
  onVisibleChange(val) {
    if (val) {
      this.loading = false
      this.file = {}
      this.fileList = []
      this.tenantIds = []
    }
  }

  // 上传文件
  handleChange(info) {
    // console.log('上传：', info)
    if (!info.fileList.length) { // 删除操作
      this.fileList = []
    }
    const status = info.file.status
    if (status !== 'uploading') {
      console.log(info.file, info.fileList)
    }
    if (status === 'done') {
      this.$message.success(`${info.file.name} file uploaded successfully.`)
    } else if (status === 'error') {
      this.$message.error(`${info.file.name} file upload failed.`)
    }
  }

  async uploadFile(info) {
    let ossfile
    this.loading = true
    this.fileList = []
    this.fileList.push(info.file)
    try {
      const res = await (await resourceService.putFileUsingPOST({fileName:info.file.name,data:info.file})).data
      ossfile = await (await resourceService.statFileUsingGET(res.name)).data

      if (ossfile) {
        this.file = ossfile
        this.file.originalName = info.file.name
        this.fileList[0].status = 'done'
      }
    } catch (e) {
      this.fileList[0].status = 'error'
    }
    this.loading = false
  }

  handleTransferChange(targetKeys, direction, moveKeys) {
    // console.log(targetKeys, direction, moveKeys)
    this.tenantIds = targetKeys
  }

  filterOption(inputValue, option) {
    return option.title.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
  }

  // 保存上传的固件
  async create() {
    if (!this.file.hasOwnProperty('name')) {
      this.$message.error('请上传文件')
      return
    }
    if (!this.tenantIds.length) {
      this.$message.error('请至少选择一个租户')
      return
    }

    this.loading = true
    const { name, hash, originalName, length } = this.file
    let md5Code = hash

    if (this.version === 'old') {
      var binary = atob(hash)
      var array = new Uint8Array(binary.length)
      for( var i = 0; i < binary.length; i++ ) { array[i] = binary.charCodeAt(i) }
  
      md5Code = Array.prototype.map.call(array, x => ('00' + x.toString(16)).slice(-2)).join('')
    }

    try {
      let fileInfo = new FileInfoDto({
        fileId: name,
        fileName: originalName,
        md5Code: md5Code,      
        size: length,
        suffix: originalName.lastIndexOf(".") > 0 ? originalName.substring(originalName.lastIndexOf(".") + 1) : "",
        tenantIds: this.tenantIds,
        version: ''
      })

      if (this.version === 'old') {
        await firmwareService.uploadFirmware(fileInfo)
      } else {
        await fsp.uploadFirmware(fileInfo)
      }
      this.$message.success(this.$t('save_success'))
      this.$emit('close', true)
    } catch (e) {
      console.log(e)
    } finally {
      this.loading = false
    }
  }

  render() {
    return (
      <a-modal
        onCancel={() => (this.$emit('close'))}
        title={this.$t('page_firmware_management_upload')}
        visible={this.visible}
        destroyOnClose={true}
        maskClosable={false}
        width={680}
        confirmLoading={this.loading}
      >
        <div slot="footer">
          <a-button
            style="margin-right:8px"
            onClick={() => (this.$emit('close'))}
          >
            {this.$t('cancel')}
          </a-button>
          <a-button type="primary" onClick={this.create} loading={this.loading}>
            {this.$t('save')}
          </a-button>
        </div>

        <div class="blue-title">{this.$t('page_firmware_management_select')}</div>
        <a-upload-dragger name="file" onChange={this.handleChange} customRequest={this.uploadFile}
                          file-list={this.fileList}>
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox"/>
          </p>
          <p class="ant-upload-text">
            {this.$t('page_firmware_management_upload_tip')}
          </p>
          <p class="ant-upload-hint">
            {this.$t('page_firmware_management_support_extend')}：.ZIP
          </p>
        </a-upload-dragger>

        <div class="blue-title">{this.$t('page_firmware_management_upload_to')}</div>
        <div class="transfer-con">
          <a-transfer
            dataSource={this.dataSource}
            showSearch
            filterOption={this.filterOption}
            targetKeys={this.tenantIds}
            render={item => item.title}
            onChange={this.handleTransferChange}
            list-style={{
              height: '300px'
            }}
          />
        </div>
      </a-modal>
    )
  }
}
